import {
  CreatedBy,
  DeliveryStatus,
  ScheduleMode,
} from '../../../../../../views/marketing/push-notifications/Constants';

export default {
  title: 'Kampagner',
  filters: {
    search: 'Søg i kampagner...',
  },
  columns: {
    title: 'Titel',
    created_by: 'Oprettet af',
    schedule_mode: 'Planlægningstilstand',
    scheduled_at: 'Planlagt til',
    sent_at: 'Sendt kl.',
    status: 'Status',
    sent: 'Sendt',
    delivered: 'Leveret',
    delivered_rate: 'Leveringsrate',
    clicks: 'Klik',
    click_rate: 'Klikrate',
    live: 'Live',
    actions: 'Handlinger',
  },
  active_status: {
    draft: 'Kladde',
    active: 'Aktiv',
  },
  delivery: {
    in_progress: 'Afventer bekræftelse',
    awaiting: 'Afventer bekræftelse',
    verified: 'Bekræftet {{relative}}',
    next_check_around: 'Næste kontrol omkring {{time}}',
  },
  breakdown: {
    delivered: '{{count}} leveret',
    pending: '{{count}} afventer bekræftelse',
    failed_title: 'Ikke leveret',
    all_delivered: 'Leveret til alle modtagere.',
    load_error: 'Leveringsoversigten kunne ikke indlæses.',
    reasons: {
      DeviceNotRegistered: 'App fjernet eller notifikationer slået fra (udløbet token)',
      MessageRateExceeded: 'Midlertidigt hastighedsbegrænset af Expo',
      MessageTooBig: 'Notifikationens indhold er for stort',
      MismatchSenderId: 'Push-legitimationsoplysninger stemmer ikke overens',
      InvalidCredentials: 'Ugyldige push-legitimationsoplysninger',
      batch_failed: 'Afsendelse af batch mislykkedes',
      missing_ticket: 'Ingen bekræftelse modtaget fra Expo',
      unknown: 'Ukendt leveringsfejl',
    },
  },
  created_by: {
    [CreatedBy.System]: 'System',
    [CreatedBy.User]: 'Bruger',
  },
  schedule_mode: {
    [ScheduleMode.Instant]: 'Øjeblikkelig',
    [ScheduleMode.Scheduled]: 'Planlagt',
  },
  delivery_status: {
    [DeliveryStatus.Sending]: 'Sender',
    [DeliveryStatus.Sent]: 'Sendt',
    [DeliveryStatus.Queued]: 'I kø',
    [DeliveryStatus.Failed]: 'Mislykkedes',
  },
  actions: {
    details: 'Detaljer',
    view_details: 'Se detaljer',
    resend: 'Send igen',
    duplicate_edit: 'Dupliker og rediger',
    delete: 'Slet',
    edit: 'Rediger',
    activate: 'Aktiver',
    deactivate: 'Deaktiver',
  },
  success_messages: {
    campaign_updated: 'Kampagnen er opdateret',
    campaign_deleted: 'Kampagnen er slettet',
  },
  error_messages: {
    failed_to_update_campaign: 'Kampagnen kunne ikke opdateres',
    failed_to_load_data: 'Data kunne ikke indlæses',
    failed_to_delete_campaign: 'Kampagnen kunne ikke slettes',
  },
};
